import { render, staticRenderFns } from "./ChatDetailsModal.vue?vue&type=template&id=74b24f1d&scoped=true&"
import script from "./ChatDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ChatDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b24f1d",
  null
  
)

export default component.exports